/**
 * Vertex AI API Service
 *
 * Service functions for interacting with the Vertex AI / Gemini integration endpoints.
 */

import { apiClient } from "./api";
import type {
  VertexConnectionCreate,
  VertexConnectionRead,
  VertexSetupInstructions,
  PaginatedVertexConnections,
} from "@/types/vertex";

const API_PREFIX = "/api/v1/vertex";

export async function getVertexSetupInstructions(): Promise<VertexSetupInstructions> {
  return apiClient.get<VertexSetupInstructions>(`${API_PREFIX}/connections/setup`);
}

export async function listVertexConnections(
  page: number = 1,
  itemsPerPage: number = 10
): Promise<PaginatedVertexConnections> {
  const params = new URLSearchParams({
    page: page.toString(),
    items_per_page: itemsPerPage.toString(),
  });
  return apiClient.get<PaginatedVertexConnections>(
    `${API_PREFIX}/connections?${params.toString()}`
  );
}

export async function createVertexConnection(
  data: VertexConnectionCreate
): Promise<VertexConnectionRead> {
  return apiClient.post<VertexConnectionRead>(`${API_PREFIX}/connections`, data);
}

export async function deleteVertexConnection(connectionId: number): Promise<void> {
  return apiClient.delete(`${API_PREFIX}/connections/${connectionId}`);
}

export async function syncVertexConnection(connectionId: number): Promise<{ id: string }> {
  return apiClient.post<{ id: string }>(
    `${API_PREFIX}/connections/${connectionId}/sync`,
    {}
  );
}
